import React from 'react'; import { Link } from 'react-router-dom'; import { useAuth } from '../context/AuthContext'; export default function Home() { const { 
  user } = useAuth(); return (
    <div className="space-y-12"> <section className="text-center py-16 bg-gradient-to-r from-green-500 to-green-700 text-white rounded-2xl"> <h1 
        className="text-5xl font-bold mb-4">Fresh from Farm to Table</h1> <p className="text-xl mb-8">Connect directly with local farmers and get the freshest 
        produce</p> <Link
          to="/products" className="bg-white text-green-600 px-8 py-3 rounded-full font-semibold hover:bg-green-50 transition"
        >
          Browse Products </Link> </section> <section className="grid md:grid-cols-3 gap-8"> <div className="bg-white p-6 rounded-lg shadow-md text-center"> 
          <div className="text-4xl mb-4">🌱</div> <h3 className="text-xl font-semibold mb-2">Farm Fresh</h3> <p className="text-gray-600">Directly from local 
          farmers to your doorstep</p>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow-md text-center"> <div className="text-4xl mb-4">🤝</div> <h3 className="text-xl font-semibold 
          mb-2">Support Local</h3> <p className="text-gray-600">Help local farmers and your community thrive</p>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow-md text-center"> <div className="text-4xl mb-4">🌍</div> <h3 className="text-xl font-semibold 
          mb-2">Sustainable</h3> <p className="text-gray-600">Eco-friendly packaging and reduced food miles</p>
        </div> </section> {!user && ( <section className="text-center py-12 bg-gray-100 rounded-2xl"> <h2 className="text-3xl font-bold mb-4">Are you a 
          farmer?</h2> <p className="text-gray-600 mb-6">Join our platform to sell your products directly to customers</p> <Link
            to="/register?role=producer" className="bg-green-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-green-700 transition"
          >
            Start Selling </Link> </section> )} </div> );
}

